import { combineReducers } from 'redux';

import { destinationReducer } from './indexPage';

export const dataSyncIndexReducer = combineReducers({
  destinations: destinationReducer,
});
